import { makeAutoObservable } from 'mobx';

export type ToastVariant = 'success' | 'error';

export interface ToastItem {
  id: number;
  message: string;
  variant: ToastVariant;
}

class ToastStoreClass {
  items: ToastItem[] = [];
  private counter = 0;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  add(message: string, variant: ToastVariant) {
    const id = ++this.counter;
    this.items.push({ id, message, variant });
    setTimeout(() => this.remove(id), 3000);
  }

  remove(id: number) {
    this.items = this.items.filter((t) => t.id !== id);
  }

  success(message: string) {
    this.add(message, 'success');
  }

  error(message: string) {
    this.add(message, 'error');
  }
}

export const toast = new ToastStoreClass();
